import React, { useState } from 'react';
import { ProjectCard } from '../components/ProjectCard';
import { Button } from '../components/ui/Button';
import { SEO } from '../components/SEO';
export function ProyekPage() {
  const [filter, setFilter] = useState('All');
  const projects = [{
    client: 'PT Jhonlin Baratama',
    project: 'Pekerjaan Workshop & Office Plant',
    location: 'Kalimantan Selatan',
    status: 'Completed',
    year: '2023',
    image: 'https://cdn.magicpatterns.com/uploads/iH4SemqE4P8m5ZTG1aF8BH/Pekerjaan_Workshop__Office_Plant.png'
  }, {
    client: 'Kemenhan',
    project: 'Pembangunan Barak & Pos Pamtas TNI',
    location: 'Perbatasan',
    status: 'On Progress',
    year: '2024',
    image: 'https://cdn.magicpatterns.com/uploads/9BDcmsiqRHmX27yGRpCJZo/Pembangunan_Barak__Pos_Pamtas_TNI.png'
  }, {
    client: 'PT Nusa Jaya Port',
    project: 'Pekerjaan Jetty & Mooring Dolphin',
    location: 'Kalimantan Selatan',
    status: 'Completed',
    year: '2023',
    image: 'https://cdn.magicpatterns.com/uploads/meR517ZCaAEAWzWqbDnYzw/Pekerjaan_Jetty__Mooring_Dolphin.png'
  }, {
    client: 'Pemkab Kotabaru',
    project: 'Pembangunan Gedung Dekranasda',
    location: 'Kotabaru',
    status: 'Completed',
    year: '2022'
  }, {
    client: 'RSUD Haji Boejasin',
    project: 'Pembangunan Lantai 6 RSUD',
    location: 'Pelaihari',
    status: 'Completed',
    year: '2022'
  }, {
    client: 'Angkasa Pura II',
    project: 'Revitalisasi MEP Terminal 1B',
    location: 'Bandara Soetta',
    status: 'Completed',
    year: '2022'
  }, {
    client: 'PDAM',
    project: 'Pembangunan PDAM Karang Bintang',
    location: 'Karang Bintang',
    status: 'Completed',
    year: '2022'
  }, {
    client: 'Dinas PU',
    project: 'Jembatan KM 17 & KM 51 Mantewe',
    location: 'Mantewe',
    status: 'Completed',
    year: '2022'
  }, {
    client: 'Private',
    project: 'Office Building Tower A',
    location: 'Jakarta',
    status: 'Concept Design',
    year: '2025'
  }, {
    client: 'Govt',
    project: 'Jalan Tol Seksi 4',
    location: 'Sumatera',
    status: 'On Going',
    year: '2024'
  }] as const;
  const filteredProjects = filter === 'All' ? projects : projects.filter(p => p.status === filter);
  return <>
      <SEO title="Portofolio Proyek - PT Wahana Konstruksi Mandiri | 44+ Proyek Terlaksana" description="Portofolio lengkap proyek konstruksi PT WKM: Gedung, infrastruktur, jalan, jembatan, pelabuhan. 44+ proyek terlaksana di Kalimantan dan Indonesia." keywords="portofolio konstruksi, proyek WKM, proyek gedung, proyek infrastruktur, proyek jalan jembatan, konstruksi Kalimantan, track record konstruksi" data-id="element-555" />

      <div className="py-12 bg-wkm-slate-50 min-h-screen" data-id="element-556">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-557">
          <div className="text-center mb-12" data-id="element-558">
            <div className="inline-block px-3 py-1 bg-wkm-gold-100 text-wkm-gold-700 rounded-full text-xs font-semibold uppercase tracking-wide mb-4" data-id="element-559">
              Portfolio
            </div>
            <h1 className="text-4xl font-bold text-wkm-navy-900 mb-4" data-id="element-560">
              Portofolio Proyek
            </h1>
            <p className="text-lg text-wkm-slate-600 max-w-2xl mx-auto" data-id="element-561">
              Rekam jejak keberhasilan kami dalam berbagai sektor konstruksi di
              Indonesia.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-2 mb-12" data-id="element-562">
            {['All', 'Completed', 'On Progress', 'On Going', 'Concept Design'].map(status => <Button key={status} variant={filter === status ? 'primary' : 'outline'} onClick={() => setFilter(status)} className="rounded-full" data-id="element-563">
                {status}
              </Button>)}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-564">
            {filteredProjects.map((p, i) => <ProjectCard key={i} {...p} data-id="element-565" />)}
          </div>

          {filteredProjects.length === 0 && <div className="text-center py-20 text-wkm-slate-500" data-id="element-566">
              Tidak ada proyek dengan status ini.
            </div>}
        </div>
      </div>
    </>;
}